// extracted by mini-css-extract-plugin
module.exports = {"planViewWrap":"index_planViewWrap_1itR-","detail":"index_detail_pxrRJ"};